(function () {
  'use strict';
  var desktop = window.matchMedia('(min-width: 990px)');
  var routes = window.theme.routes;
  var strings = window.theme.strings;

  /* Announcement rotation */
  var ann = document.querySelectorAll('.announce__item');
  if (ann.length > 1) {
    var ai = 0;
    setInterval(function () {
      ann[ai].classList.remove('is-active');
      ai = (ai + 1) % ann.length;
      ann[ai].classList.add('is-active');
    }, 4500);
  }

  /* Drawers */
  var lastFocus = null;
  function getDrawer(name) { return document.querySelector('[data-drawer="' + name + '"]'); }
  function openDrawer(name) {
    var d = getDrawer(name);
    if (!d) return false;
    document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = d.querySelector('.drawer__head button');
    if (f) f.focus({ preventScroll: true });
    return true;
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus) { lastFocus.focus({ preventScroll: true }); lastFocus = null; }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-drawer-open],[data-menu-open],[data-cart-open],[data-drawer-close]');
    if (!t) return;
    if (t.hasAttribute('data-drawer-close')) { closeDrawer(t.closest('.drawer')); return; }
    var name = t.getAttribute('data-drawer-open') || (t.hasAttribute('data-menu-open') ? 'menu' : 'cart');
    if (name === 'cart' && document.body.classList.contains('template-cart')) return;
    if (openDrawer(name)) e.preventDefault();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  });

  /* Search toggle */
  var searchBtn = document.querySelector('[data-search-open]');
  var searchBar = document.querySelector('[data-searchbar]');
  if (searchBtn && searchBar && !document.body.classList.contains('template-search')) {
    searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      searchBar.hidden = !searchBar.hidden;
      if (!searchBar.hidden) searchBar.querySelector('input[type="search"]').focus();
    });
  }

  /* Cart */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    var btn = document.querySelector('.cart-btn');
    if (btn) { btn.classList.remove('is-bump'); void btn.offsetWidth; btn.classList.add('is-bump'); }
  }
  function renderDrawer(html) {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer]');
    if (!fresh) return;
    drawer.querySelector('.drawer__panel').innerHTML = fresh.querySelector('.drawer__panel').innerHTML;
    var countEl = fresh.querySelector('[data-cart-drawer-count]');
    if (countEl) setCount(parseInt(countEl.getAttribute('data-cart-drawer-count'), 10) || 0);
  }
  function addToCart(body) {
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);
    return fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || strings.error);
        if (res.data.sections) renderDrawer(res.data.sections['cart-drawer']);
        if (!document.body.classList.contains('template-cart')) openDrawer('cart');
        else window.location.reload();
        return res.data;
      });
  }
  function changeLine(line, qty, container) {
    container.classList.add('is-updating');
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (document.querySelector('[data-cart-page]') && container.closest('[data-cart-page]')) { window.location.reload(); return; }
      if (cart.sections) renderDrawer(cart.sections['cart-drawer']);
      else setCount(cart.item_count);
      container.classList.remove('is-updating');
    }).catch(function () { container.classList.remove('is-updating'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line][data-qty]');
    if (!b) return;
    e.preventDefault();
    var box = b.closest('.line') || b.closest('.lines');
    changeLine(parseInt(b.dataset.line, 10), Math.max(0, parseInt(b.dataset.qty, 10)), box);
  });

  /* Quick add on product cards */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-qa-toggle]');
    if (toggle) {
      var panel = toggle.parentNode.querySelector('[data-qa]');
      var open = !panel.classList.contains('is-open');
      document.querySelectorAll('[data-qa].is-open').forEach(function (p) {
        p.classList.remove('is-open');
        var tg = p.parentNode.querySelector('[data-qa-toggle]');
        if (tg) tg.setAttribute('aria-expanded', 'false');
      });
      panel.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var size = e.target.closest('.qa__size');
    if (size && !size.disabled) {
      size.classList.add('is-loading');
      var fd = new FormData();
      fd.append('id', size.dataset.variantId);
      fd.append('quantity', '1');
      addToCart(fd).catch(function (err) { alert(err.message); }).then(function () {
        size.classList.remove('is-loading');
        var p = size.closest('[data-qa]');
        if (p) p.classList.remove('is-open');
      });
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    btn.classList.add('is-loading');
    addToCart(new FormData(form)).catch(function (err) { alert(err.message); }).then(function () { btn.classList.remove('is-loading'); });
  });

  /* Infinite loading */
  var more = document.querySelector('[data-load-more]');
  var grid = document.querySelector('[data-grid]');
  if (more && grid && 'IntersectionObserver' in window) {
    var loading = false;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || loading) return;
      var next = more.querySelector('[data-next]');
      if (!next) return;
      loading = true;
      fetch(next.href).then(function (r) { return r.text(); }).then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        doc.querySelectorAll('[data-grid] > li').forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
        var nn = doc.querySelector('[data-load-more] [data-next]');
        if (nn) next.href = nn.href; else { more.remove(); io.disconnect(); }
        loading = false;
      }).catch(function () { loading = false; });
    }, { rootMargin: '900px 0px' });
    io.observe(more);
  }

  /* Product page */
  var root = document.querySelector('[data-product]');
  if (root) {
    var product = JSON.parse(root.querySelector('[data-product-json]').textContent);
    var inventory = {};
    try { inventory = JSON.parse(root.querySelector('[data-inventory-json]').textContent); } catch (err) {}
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add]');
    var priceWrap = root.querySelector('[data-price-wrap]');
    var errorEl = root.querySelector('[data-form-error]');
    var stockEl = root.querySelector('[data-stock]');
    var fieldsets = root.querySelectorAll('[data-option-index]');
    var mediaList = root.querySelector('[data-media-list]');
    var dots = root.querySelectorAll('.pdp__dots span');
    var sticky = root.querySelector('[data-sticky-atc]');
    var stickyBtn = root.querySelector('[data-sticky-add]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';

    var money = function (cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: currency }).format(cents / 100); }
      catch (err) { return (cents / 100).toFixed(2); }
    };
    var selected = function () {
      return Array.prototype.map.call(fieldsets, function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    };
    var findVariant = function (opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    };
    var markAvailability = function (opts) {
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('.opt__value').forEach(function (label) {
          var test = opts.slice();
          test[idx] = label.querySelector('input').value;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return test[i] == null || o === test[i]; });
          });
          label.classList.toggle('is-unavailable', !ok);
        });
      });
    };
    var showStock = function (variant) {
      if (!stockEl) return;
      var low = parseInt(stockEl.dataset.low, 10) || 0;
      var q = variant ? inventory[variant.id] : null;
      if (variant && variant.available && low > 0 && q != null && q > 0 && q <= low) {
        stockEl.textContent = (stockEl.dataset.tpl || '').replace('__N__', q);
        stockEl.className = 'pdp__stock';
        stockEl.hidden = false;
      } else if (variant && variant.available && stockEl.dataset.ok) {
        stockEl.textContent = stockEl.dataset.ok;
        stockEl.className = 'pdp__stock is-ok';
        stockEl.hidden = false;
      } else {
        stockEl.hidden = true;
      }
    };
    var update = function () {
      var opts = selected();
      var variant = findVariant(opts);
      markAvailability(opts);
      fieldsets.forEach(function (fs, i) {
        var label = fs.querySelector('[data-option-value]');
        if (label) label.textContent = opts[i] || '';
      });
      showStock(variant);
      if (!variant) {
        addBtn.disabled = true; addBtn.textContent = strings.unavailable;
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? strings.add : strings.soldOut;
      if (stickyBtn) stickyBtn.disabled = !variant.available;
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (priceWrap) {
        priceWrap.innerHTML = '<span class="price">' + (variant.compare_at_price > variant.price
          ? '<s class="price__compare">' + money(variant.compare_at_price) + '</s><span class="price__sale">' + money(variant.price) + '</span>'
          : money(variant.price)) + '</span>';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.featured_media && mediaList) {
        var item = mediaList.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (item) {
          if (desktop.matches) item.scrollIntoView({ behavior: 'smooth', block: 'center' });
          else mediaList.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        }
      }
    };
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (stockEl) {
      stockEl.dataset.tpl = stockEl.getAttribute('data-tpl') || '';
    }
    markAvailability(selected());
    showStock(product.variants.find(function (v) { return String(v.id) === idInput.value; }));

    if (mediaList && dots.length) {
      mediaList.addEventListener('scroll', function () {
        var i = Math.round(mediaList.scrollLeft / mediaList.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }, { passive: true });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        errorEl.hidden = true;
        addToCart(new FormData(form)).catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        }).then(function () { addBtn.disabled = false; });
      });
    }

    var cta = root.querySelector('[data-main-cta]');
    if (sticky && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(cta);
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }
  }

  /* Recommendations */
  var rec = document.querySelector('[data-recommendations]');
  if (rec && rec.dataset.url && !rec.querySelector('.grid')) {
    fetch(rec.dataset.url).then(function (r) { return r.text(); }).then(function (text) {
      var fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) rec.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }
})();
